import { render, staticRenderFns } from "./dynamicsRegionMap.vue?vue&type=template&id=4407b80a&scoped=true"
import script from "./dynamicsRegionMap.vue?vue&type=script&lang=js"
export * from "./dynamicsRegionMap.vue?vue&type=script&lang=js"
import style0 from "./dynamicsRegionMap.vue?vue&type=style&index=0&id=4407b80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4407b80a",
  null
  
)

export default component.exports